import DischargeService from "../../Services/DischargeService";

// ── Action Types ────────────────────────────────────────────────────────────
export const SET_DISCHARGE_FIELD = "SET_DISCHARGE_FIELD";
export const SET_DISCHARGE_NESTED_FIELD = "SET_DISCHARGE_NESTED_FIELD";
export const SET_DISCHARGE_ARRAY_ITEM = "SET_DISCHARGE_ARRAY_ITEM";
export const ADD_DISCHARGE_ARRAY_ITEM = "ADD_DISCHARGE_ARRAY_ITEM";
export const REMOVE_DISCHARGE_ARRAY_ITEM = "REMOVE_DISCHARGE_ARRAY_ITEM";
export const LOAD_DISCHARGE_SUMMARY_DATA = "LOAD_DISCHARGE_SUMMARY_DATA";
export const RESET_DISCHARGE_SUMMARY = "RESET_DISCHARGE_SUMMARY";

export const SAVE_DISCHARGE_REQUEST = "SAVE_DISCHARGE_REQUEST";
export const SAVE_DISCHARGE_SUCCESS = "SAVE_DISCHARGE_SUCCESS";
export const SAVE_DISCHARGE_FAILURE = "SAVE_DISCHARGE_FAILURE";

export const FETCH_DISCHARGE_REQUEST = "FETCH_DISCHARGE_REQUEST";
export const FETCH_DISCHARGE_SUCCESS = "FETCH_DISCHARGE_SUCCESS";
export const FETCH_DISCHARGE_FAILURE = "FETCH_DISCHARGE_FAILURE";

// ── Action Creators ─────────────────────────────────────────────────────────

export const setDischargeField = (field, value) => ({
  type: SET_DISCHARGE_FIELD,
  payload: { field, value },
});

export const setDischargeNestedField = (parent, field, value) => ({
  type: SET_DISCHARGE_NESTED_FIELD,
  payload: { parent, field, value },
});

export const addDischargeArrayItem = (arrayName, item) => ({
  type: ADD_DISCHARGE_ARRAY_ITEM,
  payload: { arrayName, item },
});

export const removeDischargeArrayItem = (arrayName, index) => ({
  type: REMOVE_DISCHARGE_ARRAY_ITEM,
  payload: { arrayName, index },
});

export const setDischargeArrayItem = (arrayName, index, field, value) => ({
  type: SET_DISCHARGE_ARRAY_ITEM,
  payload: { arrayName, index, field, value },
});

export const loadDischargeSummaryData = (data) => ({
  type: LOAD_DISCHARGE_SUMMARY_DATA,
  payload: data,
});

export const resetDischargeSummary = () => ({
  type: RESET_DISCHARGE_SUMMARY,
});

/**
 * Fetch Discharge Summary Thunk (GET /dischargeSummary/list/filter)
 */
export const fetchDischargeSummaryAction = (filters, defaults = {}) => async (dispatch) => {
  dispatch({ type: FETCH_DISCHARGE_REQUEST });
  try {
    const payload = {
      admissionId: filters?.admissionId || "",
      pageNo: filters?.pageNo || 1,
      pageSize: filters?.pageSize || 30,
      patientId: filters?.patientId || "",
    };

    const res = await DischargeService.getDischargeSummaryList(payload);
    const resData = res?.data;

    let record = null;
    if (Array.isArray(resData) && resData.length > 0) {
      record = resData[0];
    } else if (Array.isArray(resData?.data) && resData.data.length > 0) {
      record = resData.data[0];
    } else if (Array.isArray(resData?.list) && resData.list.length > 0) {
      record = resData.list[0];
    } else if (resData?.dischSummaryId || resData?.dischargeSummaryId) {
      record = resData;
    }

    if (record && (record.dischSummaryId || record.dischargeSummaryId)) {
      // Data already available -> UPDATE flow
      const summaryId = record.dischSummaryId || record.dischargeSummaryId;
      const normalized = {
        ...record,
        dischSummaryId: summaryId,
        patientId: record.patientId || defaults.patientId || filters.patientId,
        encounterId:
          record.encounterId ||
          record.admissionId ||
          defaults.admissionId ||
          filters.admissionId,
        dischargeDiagnosis: Array.isArray(record.dischargeDiagnosis)
          ? record.dischargeDiagnosis.map((item) => ({
              ...item,
              dischSummaryId: summaryId,
            }))
          : [],
        dischargeAllergy: Array.isArray(record.dischargeAllergy)
          ? record.dischargeAllergy.map((item) => ({
              ...item,
              dischSummaryId: summaryId,
            }))
          : [],
        dischargeTreatmentSummary: record.dischargeTreatmentSummary
          ? { ...record.dischargeTreatmentSummary, dischSummaryId: summaryId }
          : {},
        dischargeMedication: Array.isArray(record.dischargeMedication)
          ? record.dischargeMedication.map((item) => ({
              ...item,
              dischSummaryId: summaryId,
            }))
          : [],
        dischargePatientInstruction: Array.isArray(record.dischargePatientInstruction)
          ? record.dischargePatientInstruction.map((item) => ({
              ...item,
              dischSummaryId: summaryId,
            }))
          : [],
        dischargeDietDtls: Array.isArray(record.dischargeDietDtls)
          ? record.dischargeDietDtls.map((item) => ({
              ...item,
              dischSummaryId: summaryId,
            }))
          : [],
        dischargeCarePlanDtls: Array.isArray(record.dischargeCarePlanDtls)
          ? record.dischargeCarePlanDtls.map((item) => ({
              ...item,
              dischSummaryId: summaryId,
            }))
          : [],
        dischargeDispositionDtls: Array.isArray(record.dischargeDispositionDtls)
          ? record.dischargeDispositionDtls.map((item) => ({
              ...item,
              dischSummaryId: summaryId,
            }))
          : [],
      };

      dispatch(loadDischargeSummaryData(normalized));
      dispatch({ type: FETCH_DISCHARGE_SUCCESS, payload: normalized });
      return { isUpdate: true, data: normalized };
    } else {
      // Data not available -> SAVE flow
      dispatch(resetDischargeSummary());
      if (defaults.patientId || filters.patientId) {
        dispatch(
          setDischargeField(
            "patientId",
            defaults.patientId || filters.patientId
          )
        );
      }
      if (defaults.admissionId || filters.admissionId) {
        dispatch(
          setDischargeField(
            "encounterId",
            defaults.admissionId || filters.admissionId
          )
        );
      }
      dispatch({
        type: FETCH_DISCHARGE_FAILURE,
        payload: "No discharge summary found",
      });
      return { isUpdate: false, data: null };
    }
  } catch (error) {
    console.warn("Discharge fetch warning (defaulting to Save flow):", error);
    dispatch(resetDischargeSummary());
    if (defaults.patientId || filters.patientId) {
      dispatch(
        setDischargeField(
          "patientId",
          defaults.patientId || filters.patientId
        )
      );
    }
    if (defaults.admissionId || filters.admissionId) {
      dispatch(
        setDischargeField(
          "encounterId",
          defaults.admissionId || filters.admissionId
        )
      );
    }
    dispatch({
      type: FETCH_DISCHARGE_FAILURE,
      payload: error?.response?.data?.message || error.message,
    });
    return { isUpdate: false, data: null };
  }
};

/**
 * Save or Update Discharge Summary Thunk
 */
export const saveDischargeSummaryAction = (payload, onSuccess) => async (dispatch) => {
  dispatch({ type: SAVE_DISCHARGE_REQUEST });
  console.log("================== DISCHARGE FINAL SAVE/UPDATE PAYLOAD ==================");
  console.log(JSON.stringify(payload, null, 2));
  console.log("Discharge Payload Object:", payload);
  console.log("=========================================================================");

  try {
    let res;
    if (payload.dischSummaryId) {
      // Update flow: PUT /dischargeSummary/update/${dischargeSummaryId}
      res = await DischargeService.DischargeUpdate(payload.dischSummaryId, payload);
    } else {
      // Save flow: POST /dischargeSummary
      res = await DischargeService.saveDischargeSummary(payload);
    }
    const savedData = res?.data?.data || res?.data;
    dispatch({ type: SAVE_DISCHARGE_SUCCESS, payload: savedData });
    if (onSuccess) onSuccess(savedData);
    return savedData;
  } catch (error) {
    console.error("Discharge Save/Update Error:", error);
    const errorMsg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to save/update Discharge Summary. Please try again.";
    dispatch({
      type: SAVE_DISCHARGE_FAILURE,
      payload: errorMsg,
    });
    throw error;
  }
};
